import React from 'react';
import { connect } from 'react-redux';

import fetchSalon from 'actions/fetchSalon.action';
import listSalons from 'actions/listSalons.action';
import LINK from 'constants/link.const';
import { selectCurrentSalon } from 'selectors/currentSalon.selectors';
import { selectSalonListObject, selectSalonManagers, selectSalonReceptionists } from 'selectors/salonInfo.selectors';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import { fromPropsToMatchedSalonId } from 'utils/converters/props/bl.util';
import { fromPropsToQueryString } from 'utils/converters/props/path.util';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import navFor from 'utils/links/navFor.util';
import logger from 'utils/logger.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

const L = logger('SalonLoader');

const checkSalonInList = ({ salonList, salonId }) => {
  for (let i = 0; i < salonList.response.manager.length; i += 1) {
    if (salonList[i].id === salonId) {
      return true;
    }
  }
  return false;
};

export class SalonLoader extends React.Component {
  UNSAFE_componentWillMount() {
    const { listSalons, salonManagers, salonReceptionists } = this.props;

    const hasAccess = isFullArray(salonManagers) || isFullArray(salonReceptionists);

    if (hasAccess) {
      this.navigateToSetup(this.props);
    } else {
      // TODO: fix forever loops in case there is no access found after first successful response
      L.unignore('componentWillMount()', 'listSalons:', listSalons());
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { salonManagers, salonReceptionists } = nextProps;

    const hasAccess = isFullArray(salonManagers) || isFullArray(salonReceptionists);

    if (hasAccess) {
      this.navigateToSetup(nextProps);
    }
  }

  navigateToSetup(options) {
    const { salonList, currentSalon: currentSalonFromOptions } = options;

    const { fetchSalon, currentSalon: currentSalonFromProps } = this.props;
    const { setSalon } = this.state;

    const salonId = fromAnyToInteger(fromPropsToMatchedSalonId(this.props));

    const isSalonInList = checkSalonInList({ salonList, salonId });
    if (!isSalonInList) {
      return;
    }

    if (currentSalonFromProps && currentSalonFromOptions.id === salonId) {
      navFor('SalonLoader.navigateToSetup()', this.props).push({
        pathname: LINK.onboardingPriceType,
        search: fromPropsToQueryString(this.props),
      });
      return;
    }

    if (!setSalon) {
      this.setState({ setSalon: true });
      L.unignore('navigateToSetup()', 'fetchSalon:', fetchSalon(salonId));
    }
  }

  render() {
    this.navigateToSetup(this.props);
    return <div />;
  }
}

const SalonLoaderHoc = connect(
  (state) => ({
    currentSalon: selectCurrentSalon(state),
    salonList: selectSalonListObject(state),
    salonManagers: selectSalonManagers(state),
    salonReceptionists: selectSalonReceptionists(state),
  }),
  mapActionsToDispatchToProps({ listSalons, fetchSalon }),
)(SalonLoader);

export default SalonLoaderHoc;
